<script setup lang="ts">
import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import type { StickyType } from "@/model/stickyType";

defineProps<{ types: ReadonlyArray<Pick<StickyType, "id" | "name" | "color">> }>();
</script>

<template>
  {{ $t("general.stickyTypes") }}
  <div v-for="type in types" :key="type.id" class="shortcut">
    <TypeDot :color="type.color" />
    {{ type.name }}
  </div>
</template>
